
export default {
    name: 'pixstar-container',
}
